import { render } from "./index.vue?vue&type=template&id=5d04fcb6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5d04fcb6&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=5d04fcb6&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d04fcb6"]])

export default __exports__